module.exports = __webpack_public_path__ + "static/media/capital.d1a4140e.svg";